import React, { useEffect } from 'react'
import PriorHbanner from '../../components/Industries/PriorHbanner'
import PriorHcore from '../../components/Industries/PriorHcore'
import PriorHpillars from '../../components/Industries/PriorHpillars'
import PriorHstats from '../../components/Industries/PriorHstats'
import PriorHintergration from '../../components/Industries/PriorHintergration'
import PriorCasestudy from '../../components/Industries/PriorCasestudy'
import PriorHsecurity from '../../components/Industries/PriorHsecurity'
import PriorHfaq from '../../components/Industries/PriorHfaq'
import PriorHCTA from '../../components/Industries/PriorHCTA'

const PriorHealthcare = () => {
   useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);
  return (
    <div>
      <PriorHbanner />
      <PriorHcore />
      <PriorHpillars />
      <PriorHstats />
      <PriorHintergration/>
      <PriorHsecurity/>
      <PriorCasestudy/>
      <PriorHfaq />
      <PriorHCTA />
    </div>
  )
}

export default PriorHealthcare
